import { ResultOf, TadaDocumentNode, VariablesOf } from "gql.tada";
import { useMemo } from "react";
import { useQuery } from "urql";
import { useGlobalContext } from "@utils/GlobalContext";

export const useContent = <Query extends TadaDocumentNode<unknown>>({
  query,
  variables,
}: {
  query: Query;
  variables?: VariablesOf<Query>;
}) => {
  const { previewContent: preview } = useGlobalContext();
  const { locale } = useGlobalContext();
  const request = useMemo(
    () => ({
      query,
      variables: {
        ...variables,
        locale,
        preview,
      },
    }),
    [query, variables, locale, preview]
  );

  return useQuery<ResultOf<Query>>(request);
};
